import React, { useEffect } from "react";
import TableLayout from "../../../../../_metronic/layout/components/table/TableLayout";
import { roles } from "../../../../App";
import { useList } from "../../../common/hooks";
import { TRANSACTIONS_CONTEXT } from "../../helpers/ModuleHelpers";
import { useModuleContext } from "../../ModuleContext";

import { transactionsColumns } from "../../tables/transactions/transactions";
import { actionTypes } from "../../_redux/transactions/slice";
import * as actions from "../../_redux/transactions/actions";
import TransactionsFilter from "./filters/TransactionsFilter";
const TransactionsList = () => {
  const {
    metadata,
    entities,

    isLoading,
  } = useList({
    CONTEXT: TRANSACTIONS_CONTEXT,
    actions,
  });
  // console.log({ transactionsColumns });
  useEffect(() => {
    // console.log({ entities });
  }, [isLoading]);

  return (
    <>
      <TableLayout
        Filter={TransactionsFilter}
        columns={transactionsColumns}
        cardTitle={"TRANSACTIONS"}
        entities={entities}
        metadata={metadata}
        isLoading={isLoading}
        resource={"transactions"}
        useModuleContext={useModuleContext}
        CONTEXT={TRANSACTIONS_CONTEXT}
        actions={actions}
        actionTypes={actionTypes}
        acceptedRoles={[roles.super_admin]}
      />
    </>
  );
};

export default TransactionsList;
